<template>
  <div v-if="fieldType == 'text'">
    <v-text-field
      :label="label"
      :value="fieldValue"
      :success-messages="successes"
      :error-messages="errors"
      @change="value => (fieldValue = value)"
      :loading="loading"
      :mask="mask"
      :prefix="prefix"
      :hint="hint"
      :persistent-hint="persistentHint"
    >
    </v-text-field>
  </div>

  <div v-else-if="fieldType == 'textarea'">
    <v-textarea
      :label="label"
      :value="fieldValue"
      :success-messages="successes"
      :error-messages="errors"
      @change="value => (fieldValue = value)"
      :loading="loading"
      :mask="mask"
      :prefix="prefix"
    >
    </v-textarea>
  </div>

  <div v-else>
    <v-text-field
      :label="label"
      :value="fieldValue"
      :success-messages="successes"
      :error-messages="errors"
      @change="value => (fieldValue = value)"
      :loading="loading"
      :mask="mask"
      :prefix="prefix"
    >
    </v-text-field>
  </div>
</template>

<script>
export default {
  props: [
    "label",
    "fieldName",
    "object",
    "mask",
    "fieldType",
    "prefix",
    "hint",
    "persistentHint"
  ],
  computed: {
    fieldValue: {
      get: function() {
        // Could not retrieve employee data from store state
        // return this.$store.state.employees.detailedEmployee[this.fieldName];

        //  Instead get data from object passed as prop
        return this.object[this.fieldName];
      },
      set: function(newValue) {
        this.loading = true;
        this.$store
          .dispatch("employees/update", {
            id: this.object.id || this.object.userId,
            [this.fieldName]: newValue
          })
          .then(res => {
            this.errors = [];
            this.successes.push("Saved!");
            this.successClear = setInterval(() => {
              this.wipeSuccesses();
            }, 1500);
          })
          .catch(res => {
            this.errors.push("Couldn't be saved");
            // reset the value?
          })
          .finally(res => {
            this.loading = false;
          });
      }
    }
  },

  methods: {
    updateField: function(newValue) {
      this.loading = true;

      this.$store.dispatch("employees/update", {
        id: this.object.id || this.object.userId,
        [this.fieldName]: newValue
      });
    },
    wipeSuccesses: function() {
      this.successes = [];
    }
  },

  data: function() {
    return {
      loading: false,
      fallback: "",
      errors: [],
      successes: []
    };
  }
};
</script>
